import _isFunction from 'lodash/isFunction';
import _isArrayLikeObject from 'lodash/isArrayLikeObject'; /**
                                                            * @author Kuitos
                                                            * @homepage https://github.com/kuitos/
                                                            * @since 2018-07-03 15:49
                                                            */

export var isObject = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
export var isMap = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Map]' || obj && _isFunction(obj.delete) && _isFunction(obj.get) && _isFunction(obj.set);
};
export var isArray = function (obj) {
  return obj && (Array.isArray(obj) || _isArrayLikeObject(obj));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mmlpx/esm/utils/types.js
// module id = null
// module chunks = 